export const BaseIntegrationOptions = [
  {
    name: "Advocado Tracking Tag",
    category: '',
    type: 'web_tracking',
    img: '../../../assets/image/advocado_inline_full_color.png',
    selected: false
  },
  {
    name: 'Google Analytics - Events',
    category: 'analytics',
    type: 'google_analytics',
    img: '../../../assets/image/google_analytics-events.svg',
    selected: false
  },
  {
    name: 'Google Analytics - Reporting',
    category: 'analytics',
    type: 'google_analytics_reporting',
    img: '../../../assets/image/google_analytics-reporting.svg',
    selected: false
  },
  {
    name: 'Google Ads',
    category: 'adPlatform',
    type: 'google_ads',
    img: '../../../assets/image/google-ads.svg',
    selected: false
  },
  {
    name: 'Google Ads Read Only',
    category: 'adPlatform',
    type: 'google_ads_read_only',
    img: '../../../assets/image/google-ads.svg',
    selected: false
  },
  {
    name: 'Facebook',
    category: 'adPlatform',
    type: 'facebook',
    img: '../../../assets/image/facebook.svg',
    selected: false
  },
  {
    name: 'Amazon',
    category: 'adPlatform',
    type: 'amazon',
    img: '../../../assets/image/amazon-logo.svg',
    selected: false
  },
  {
    name: 'Twitter',
    category: 'adPlatform',
    type: 'twitter',
    img: '../../../assets/image/twitter-logo.svg',
    selected: false
  },
  {
    name: 'Snapchat',
    category: 'adPlatform',
    type: 'snapchat',
    img: '../../../assets/image/snap-logo.svg',
    selected: false
  },
  {
    name: 'Bing Ads',
    category: 'adPlatform',
    type: 'bing',
    img: '../../../assets/image/Bing_Ads_logo.svg',
    selected: false
  },
  {
    name: 'Google Drive',
    category: 'adPlatform',
    type: 'google_drive',
    img: '../../../assets/image/google-drive-logo.svg',
    selected: false
  },
  {
    name: 'S3',
    category: 'adPlatform',
    type: 's3',
    img: '../../../assets/image/s3-logo.svg',
    selected: false
  },
  {
    name: 'The Trade Desk',
    category: 'adPlatform',
    type: 'trade-desk',
    img: '../../../assets/image/the-trade-desk.svg',
    selected: false
  },
  {
    name: 'Advocado FTP',
    category: 'dataDestination',
    type: 'ftp',
    img: '../../../assets/image/ftp.svg',
    selected: false
  }
]